import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../documento.actions'
import { DocumentoForm } from './DocumentoForm'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  return {
    record: state.crudDocumentoState.currentRecord,
    messages: state.crudDocumentoState.messages,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let value = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, value))
    },
    setField: (field, value) => {
      dispatch(actions.setField(field, value))
    },
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
  }
}

class DocumentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_DOCUMENTO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_DOCUMENTO}/novo`)
      this.props.setField('entidadeBase', 'br.com.lottustech.phoenix.contrato.Contrato')
      this.props.setField('tipoTela', { id: 1, value: 'Formulário' })
      this.props.setField('nomeRelatorio', 'DeclaracaoReport_V4')
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_DOCUMENTO}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_DOCUMENTO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <DocumentoForm
        record={this.props.record}
        changeHandler={this.props.changeHandler}
        setField={this.props.setField}
        messages={this.props.messages}
      />
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentoFormPageContainer)
